/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Check_In_Journey_Complete_DescriptionInputs */

const en_check_in_journey_complete_description = /** @type {(inputs: Check_In_Journey_Complete_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You have collected all free credits and creative prompt rewards in this journey.`)
};

const es_check_in_journey_complete_description = /** @type {(inputs: Check_In_Journey_Complete_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Has reunido todos los créditos gratis y prompts creativos de este recorrido.`)
};

/**
* | output |
* | --- |
* | "You have collected all free credits and creative prompt rewards in this journey." |
*
* @param {Check_In_Journey_Complete_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const check_in_journey_complete_description = /** @type {((inputs?: Check_In_Journey_Complete_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Check_In_Journey_Complete_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_check_in_journey_complete_description(inputs)
	return es_check_in_journey_complete_description(inputs)
});